import makeObservable from '../utils/makeObservable';

export const EDITOR_SELECTION_STORE = makeObservable([]);